<template>
  <transition name="fade">
    <div
      v-if="showing"
      class="wishlist-add-success-modal__success"
      :style="{
        'top': offsetTop
      }"
    >
      <div class="wishlist-add-success-modal__success-left">
        <icon-check />

        <p
          class="
          wishlist-add-success-modal__success-title
          text-body-2xs-regular
        "
          v-text="$string('customers.favorites.added_to_favorites', {
            replace: { name: $variable('customer.firstName') }
          })"
        />
      </div>

      <btn
        class="wishlist-add-success-modal__view-wishlist"
        :label="$string('customers.favorites.view')"
        class-label="text-body-2xs-regular"
        :url="`${$variable('routes.account.url')}?view=favorites`"
        modifiers="text center"
      />
    </div>
  </transition>
</template>

<script>

/**
 * Vue: Wishlist Added Success Modal
 * -----------------------------------------------------------------------------
 * Wishlist success pop-up.
 *
 */
import { mapState } from 'vuex'
import Btn from '~global/btn/btn'
import IconCheck from '~icons/general/check.svg'

export default {
  name: 'WishlistAddSuccessModal',

  components: {
    Btn,
    IconCheck,
  },

  data() {
    return {
      showing: false,
    }
  },

  computed: {

    /**
     * Map Vuex state
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
      headerState: (state) => state.index.scroll.header,
    }),

    /**
     * Compute desktop offset from top. Interacts with the header state.
     */
    offsetTop() {
      if (this.isMobile) {
        return ''
      }

      const states = {
        collapsed: 'var(--spacing-m)',
        minimised: 'calc(var(--header-visible-height) + var(--spacing-m))',
      }

      return states[this.headerState] || ''
    },
  },

  mounted() {
    window.showWishlistAddSuccess = this.showSuccessMessage
  },

  methods: {

    /**
     * Displays success message when item added to wishlist
     */
    showSuccessMessage() {
      this.showing = true

      setTimeout(() => {
        this.showing = false
      }, this.$timing('message'))
    },

  },
}

</script>

<style lang="scss">
@import './wishlist-add-success-modal';
</style>
